import SectionBanner from "components/cards/SectionBanner";
import IntentList from "./IntentList_";
import DatatrainingIMG from 'assets/images/data-training.png'
import { useTranslation } from "react-i18next";
import SectionWrapper from "components/wrappers/SectionWrapper";
import { ExportCSV } from "components/ExportCSV";
import { useEffect, useState } from "react";
import DataTrainingService from "api/services/DataTrainingService";
import DashboardWrapper from "components/wrappers/DashboardWrapper"


const DataTraining = () => {
    const { t } = useTranslation();
    const [uMessagesWithNewIntent, setUMessagesWithNewIntent] = useState()

    useEffect(() => {
        DataTrainingService.getUMessagesWithNewIntent().then((resp) => {
            setUMessagesWithNewIntent(resp)
        }).catch((err) => {
            //Handle error ..
            console.log(err)
        });
    }, [])

    return (
        <DashboardWrapper>


            <SectionBanner
                title={t('data_training.title')}
                desc={t('data_training.description')}
            >
                <img src={DatatrainingIMG} alt='' height='100px' width='100px' />
            </SectionBanner>

            <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-4 rounded" role="alert">
                <p className="font-bold">{t('data_training.notice.title')}</p>
                <p className="text-sm font-medium">{t('data_training.notice.description')}</p>
            </div>

            <SectionWrapper
                title={t('data_training.u_messages_with_new_intent.title')}
                description={t('data_training.u_messages_with_new_intent.description')}
                actions={<ExportCSV csvData={uMessagesWithNewIntent?.data} disabled={!uMessagesWithNewIntent?.data} fileName={`messages_assigned_with_new_intent`} />}
                className="border bg-white"
            >
            </SectionWrapper>
            <div className="mt-8">
                <IntentList />
            </div>

            </DashboardWrapper>

    );
}

export default DataTraining;




